import { diffChars } from 'diff'
export const TextDiff = (text: string, editText?: string) => {
  if (editText === undefined) {
    return text
  }
  const diff = diffChars(text, editText)

  return diff.map((part, index) => {
    const { added, removed, value } = part

    if (added) {
      return (
        <span key={index} style={{ color: 'red' }}>
          {value}
        </span>
      )
    }
    if (!removed) {
      return value
    }

    return null
  })
}
